import { Badge } from "@components/ui/badge";
import { ATTACHMENT_LABEL_MAP } from "@academy-context/shared/external-provider-batch/types/provider-training-form.types";
import type { AttachmentDisplayData } from "./types";

interface AttachmentsDisplayProps {
  attachments: AttachmentDisplayData[];
  variant: "admin" | "provider";
  withTopBorder: boolean;
}

const DEFAULT_TITLES = {
  admin: "Pièces jointes",
  provider: "Documents fournis par l'élève",
} as const;

/**
 * Shared component to display a list of attachments with labels and links.
 * Used by both admin and provider portal views.
 */
export const AttachmentsDisplay = ({ attachments, variant, withTopBorder }: AttachmentsDisplayProps) => {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  const title = DEFAULT_TITLES[variant];
  const borderClass = withTopBorder ? "border-t border-muted-foreground/20 pt-4" : "";

  return (
    <div className={`space-y-2 ${borderClass}`}>
      <div className="text-sm font-medium">
        {title} ({attachments.length})
      </div>
      <div className="space-y-2">
        {attachments.map(attachment => {
          const labelText = ATTACHMENT_LABEL_MAP[attachment.label];

          return (
            <div key={attachment.url} className="flex items-center gap-2">
              <Badge variant="outline" className="text-xs">
                {labelText}
              </Badge>
              <a
                href={attachment.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:underline dark:text-blue-400"
              >
                Voir le document
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
